/*
 * @Author: Teemo Ding
 * @Date: 2022-02-16 15:13:03
 * @LastEditTime: 2022-02-17 16:53:53
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/tool.ts
 */
import {
  CommunicationChannelType,
  CommunicationGatewayProvider,
} from '@/src/types/common/communication';

export const calculateCommunication = (gateway, channelType, { getI18n }) => {
  switch (channelType) {
    case CommunicationChannelType.SMS: {
      return gateway === CommunicationGatewayProvider.Twilio
        ? {
            gateway: `${gateway} ${channelType}`,
            channelType: `${channelType} (${getI18n(
              'storeCommunicationSetting.tool.global',
            )})`,
          }
        : {
            gateway,
            channelType: `${channelType} (${getI18n(
              'storeCommunicationSetting.tool.mainlandChina',
            )})`,
          };
    }
    // case CommunicationChannelType.PhoneNumberValidation: {
    //   return {
    //     gateway: `${gateway} Phone Validation`,
    //     channelType: `Phone Validation`,
    //   };
    // }
    case CommunicationChannelType.WhatsApp: {
      return {
        gateway: `${gateway} ${getI18n(
          'storeCommunicationSetting.tool.whatsapp',
        )}`,
        channelType: getI18n('storeCommunicationSetting.tool.whatsappMessage'),
      };
    }
    case CommunicationChannelType.LiveChat: {
      return {
        gateway: getI18n('storeCommunicationSetting.tool.zhiMaKeFu'),
        channelType,
      };
    }
    default:
      return {
        gateway: gateway,
        channelType,
      };
  }
};
